import Claim from './claimType';
import Offer from './offerType';
import Project from './projectType';

enum ResourceType {
    PROJECT = 'project',
    OFFER = 'offer',
    CLAIM = 'claim',
    CART = 'cart',
    INSPECTION = 'inspection',
    CUSTOMER = 'customer',
}

export type Resource = Project | Offer | Claim;

export enum TimeSelectorResourceType {
    PROJECT = 'project',
    OFFER = 'offer',
    CART = 'cart',
    CLAIM = 'claim',
    SOLAR_INSPECTION = 'solar-inspection',
    VIDEO_INSPECTION = 'video-inspection',
}

export default ResourceType;
